interface FileIcon {
	icon: string;
	color: string;
}

const getFileIcon = (object: string, type: string): FileIcon => {
	if (object === 'FILE') {
		switch (type) {
			// PDF
			case 'application/pdf':
				return { icon: 'fas fa-file-pdf', color: '#f44336' };
			// Word document
			case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
			case 'application/vnd.oasis.opendocument.text':
			case 'application/msword':
				return { icon: 'fas fa-file-word', color: '#1e88e5' };
			// Word document template
			case 'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
			case 'application/vnd.oasis.opendocument.text-template':
				return { icon: 'fas fa-palette', color: '#1e88e5' };
			// Spreadsheet
			case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
			case 'application/vnd.oasis.opendocument.spreadsheet':
			case 'application/vnd.ms-excel':
				return { icon: 'fas fa-file-excel', color: '#009900' };
			// Spreadsheet template
			case 'application/vnd.openxmlformats-officedocument.spreadsheetml.template':
				return { icon: 'fas fa-palette', color: '#009900' };
			// Presentation
			case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
			case 'application/vnd.ms-powerpoint':
				return { icon: 'fas fa-file-powerpoint', color: '#ff9800' };
			// Presentation template
			case 'application/vnd.openxmlformats-officedocument.presentationml.template':
				return { icon: 'fas fa-palette', color: '#ff9800' };
			// Text
			case 'text/plain':
			case 'application/rtf':
				return { icon: 'fas fa-font', color: '#546e7a' };
			// CSV
			case 'text/csv':
				return { icon: 'fas fa-file-csv', color: '#546e7a' };
			// Email message
			case 'message/rfc822':
			case 'application/vnd.ms-outlook':
				return { icon: 'fas fa-envelope-open-text', color: '#546e7a' };
			// DWG
			case 'image/vnd.dwg':
				return { icon: 'fas fa-swatchbook', color: '#ef6c00' };
			// Code
			case 'text/html':
			case 'text/xml':
			case 'application/json':
			case 'application/x-javascript':
			case 'application/postscript':
			case 'ext/x-java-source':
				return { icon: 'fas fa-code', color: '#009688' };
			// Image
			case 'image/png':
			case 'image/gif':
			case 'image/jpeg':
			case 'image/svg+xml':
			case 'image/tiff':
			case 'image/vnd.adobe.photoshop':
				return { icon: 'far fa-image', color: '#FF4081' };
			// Audio
			case 'audio/x-wav':
			case 'audio/mpeg':
			case 'audio/x-flac':
			case 'audio/vorbis':
				return { icon: 'fas fa-music', color: '#FF4081' };
			// Video
			case 'video/webm':
			case 'video/x-msvideo':
			case 'video/quicktime':
			case 'video/x-ms-wmv':
			case 'video/mp4':
				return { icon: 'fas fa-play', color: '#009688' };
			// Archive
			case 'application/x-rar-compressed':
			case 'application/zip':
			case 'application/x-tar':
				return { icon: 'fas fa-folder-open', color: '#546e7a' };
			// Certificate
			case 'application/x-x509-ca-cert':
				return { icon: 'fas fa-award', color: '#e53935' };
			// fallback
			default:
				return { icon: 'far fa-file-alt', color: '#546e7a' };
		}
	} else {
		return { icon: 'fas fa-folder', color: '#ffc107' };
	}
};

export default getFileIcon;
